module.exports = __webpack_public_path__ + "img/noPicture.8d924d41.jpg";